import angular from 'angular';

import component from './cta-button-details.component';

const CtaButtonDetails = angular
    .module('control-room.commons.form.components.cta-button-details', [])
    .component('crCtaButtonDetails', component);

export default CtaButtonDetails;
